<template>
  <v-container
    id="notifications-view"
    fluid
    tag="section"
  >
    <material-card
      icon="$notifications"
      icon-small
      color="accent"
      :title="page_title"
      help="notifications"
    >
      <v-card-title>
        <v-switch
          v-model="show_all"
          class="ml-2"
          :label="$t('show_all_notifications')"
        />
        <v-spacer />
        <v-text-field
          v-model="search"
          append-icon="$search"
          class="ml-auto"
          hide-details
          :label="$t('search_records')"
          single-line
          style="max-width: 250px;"
        />
      </v-card-title>
      <v-card-text>
        <v-data-table
          :headers="table_headers"
          :items="items"
          :loading="loading"
          :loading-text="$t('loading')"
          :options.sync="options"
          :server-items-length="total"
          :footer-props="footerProps"
          :item-class="row_classes"
          multi-sort
          show-expand
          :single-expand="singleExpand"
          :expanded.sync="expanded"
          @item-expanded="read"
        >
          <template #item.data.message="{item}">
            {{ $t(item.data.message) }}
          </template>
          <template #item.created_at="{item}">
            {{ item.created_at | dateTimeFormat }}
          </template>
          <template v-slot:expanded-item="{ headers, item }">
            <td :colspan="headers.length" class="ma-3 pa-6">
              <div v-if="item.data.mail" v-html="base64decode(item.data.mail)" />
              <div v-if="item.data.action">
                <v-btn
                  :disabled="item.data.accepted"
                  @click="clickAcceptNotification(item)"
                >
                  {{ item.data.accepted ? $t('accepted') : $t('accept') }}
                </v-btn>
              </div>
            </td>
          </template>
          <template #item.actions="{item}">
            <tooltip-btn
              v-for="(action, i) in actions"
              :key="i"
              :show="!action.disable"
              :color="action.color"
              :icon="action.icon"
              :tooltip="action.tooltip"
              @click="action.func(item)"
            />
          </template>
        </v-data-table>
      </v-card-text>
    </material-card>
  </v-container>
</template>

<script>
  // Utilities
  import { get, call, sync, dispatch } from 'vuex-pathify'

  export default {
    name: 'Notifications',
    data () {
      return {
        items: [],
        expanded: [],
        singleExpand: true,
        // table
        footerProps: {
          itemsPerPageOptions: [10, 20, 25, 50, 100],
        },
        total: 0,
        timer: null,
        show_all: true,
        current_notification_id: null,
      }
    },
    computed: {
      loading: get('app/loading'),
      profile: get('auth/profile'),
      options: sync('profile/notification_options'),
      search: sync('profile/notification_search'),
      table_headers () {
        return [
          {
            text: this.$t('fields.date'),
            align: 'start',
            sortable: false,
            value: 'created_at',
          },
          {
            text: this.$t('fields.message'),
            align: 'start',
            sortable: false,
            value: 'data.message',
          },
          {
            value: 'actions',
            sortable: false,
            align: 'right',
          },
        ]
      },
      actions () {
        return [
          { color: 'delete', icon: '$delete', tooltip: 'tooltip_delete', func: this.clickDeleteNotification },
        ]
      },
      broadcast_notifications: sync('profile/notifications'),
      page_title () { return this.$t('notifications') },
      // editor () { return this.profile.can['transaction-edit'] },
    },

    watch: {
      search: {
        handler () {
          if (this.timer) {
            clearTimeout(this.timer)
            this.timer = null
          }
          this.timer = setTimeout(() => {
            this.options.page = 1
            this.load()
          }, 800)
        },
        deep: true,
      },
      options: {
        handler () {
          this.load()
        },
        deep: true,
      },
      show_all: {
        handler () {
          this.load()
        },
        deep: true,
      },
      broadcast_notifications: {
        handler (val) {
          if (val) {
            this.load()
          }
        },
      },

    },
    mounted () {
      this.current_notification_id = this.$route.params.id ?? null
      // this.load()
    },
    methods: {
      getList: call('profile/searchNotifications'),
      setNotificationRead: call('profile/setNotificationRead'),
      deleteNotification: call('profile/deleteNotification'),
      acceptNotification: call('action/accept'),
      refreshProfile: call('auth/refreshProfile'),
      async load () {
        try {
          const { sortBy, sortDesc, page, itemsPerPage } = this.options
          await this.getList({
            page: page,
            per_page: itemsPerPage,
            sort: {
              field: sortBy,
              order: sortDesc,
            },
            search: this.search,
            show_all: this.show_all,
          }).then(response => {
            this.items = response.data
            this.total = response.total
            if (this.current_notification_id) {
              // console.log(this.items.filter(r => r.id === this.current_notification_id))
              this.expanded = this.items.filter(r => r.id === this.current_notification_id)
              // console.log(this.items.filter(r => r.id === this.current_notification_id)[0])
              this.read(this.items.filter(r => r.id === this.current_notification_id)[0])
            }
          }).catch(e => {
            console.log(e)
          })
        } catch (e) {
        }
      },
      row_classes (item) {
        if (item.read_at === null) {
          // console.log(item.read_at)
          return 'font-weight-bold'
        }
      },
      read (item) {
        const notification = item.item ? item.item : item
        if (notification.read_at === null) {
          this.setNotificationRead({ id: notification.id }).then(response => {
            notification.read_at = new Date()
          }).catch(e => {
            console.log(e)
          })
        }
      },
      base64decode (item) {
        return decodeURIComponent(escape(window.atob(item)))
      },
      clickAcceptNotification (item) {
        this.acceptNotification({ id: item.id }).then(response => {
          item.data.accepted = true
          dispatch('alert/setSnackbar', { text: response, type: 'success' })
          this.refreshProfile()
          console.log('Success')
        }).catch(e => {
          dispatch('alert/setSnackbar', { text: e.message, type: 'error' })
        })
      },
      clickDeleteNotification (item) {
        this.deleteNotification(
          { id: item.id },
        ).then(response => {
          this.items.splice(this.items.indexOf(item), 1)
        }).catch(e => {
          this.loading = false
          this.$refs.form.setErrors(e)
          console.log(e)
        })
      },
    },
  }
</script>
<style lang="sass">
  .font-weight-bold
    td
      font-weight: bolder !important
</style>
